/**
 * @generated SignedSource<<c6a296dd25d34567e014e3a9c98131ac>>
 * @relayHash 81dcf359b30000a517e5ce087cc79e86
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b063ba228370d5fba218c9ac6f8f6f02b4a7bf51cadbab48b4ff24c5a59ed372

import type { ConcreteRequest } from 'relay-runtime';
export type useCommentActionsReactionsCommentsQuery$variables = {
  containerId: string;
  contentId: string;
};
export type useCommentActionsReactionsCommentsQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly reactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
    } | null> | null;
  } | null;
};
export type useCommentActionsReactionsCommentsQuery = {
  response: useCommentActionsReactionsCommentsQuery$data;
  variables: useCommentActionsReactionsCommentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "contentStatus",
        "value": [
          "DRAFT",
          "CURRENT"
        ]
      }
    ],
    "concreteType": "PaginatedCommentList",
    "kind": "LinkedField",
    "name": "comments",
    "plural": false,
    "selections": [
      {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
              },
              {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "containerId"
              }
            ],
            "concreteType": "ReactionsSummaryResponse",
            "kind": "LinkedField",
            "name": "reactionsSummary",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "reactionsCount"
              },
              {
                "kind": "ScalarField",
                "name": "ari"
              },
              {
                "kind": "ScalarField",
                "name": "containerAri"
              },
              {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "emojiId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "count"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "reacted"
                  },
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCommentActionsReactionsCommentsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCommentActionsReactionsCommentsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "81dcf359b30000a517e5ce087cc79e86",
    "id": "b063ba228370d5fba218c9ac6f8f6f02b4a7bf51cadbab48b4ff24c5a59ed372",
    "metadata": {},
    "name": "useCommentActionsReactionsCommentsQuery",
    "operationKind": "query",
    "text": "query useCommentActionsReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
  }
};
})();

(node as any).hash = "fce76fc1c4120dae9d5f8be1dcf92955";

export default node;
